<template>
  <select
    :aria-label="$t(`selectLanguage`)"
    v-model="$i18n.locale"
    class="language-switch reset-this-parent minimal"
    @change="setHtmlLang($i18n.locale)"
    data-test="language-select"
  >
    <option value="en">EN</option>
    <option value="nl">NL</option>
    <option value="fr">FR</option>
    <option value="de">DE</option>
    <option value="es">ES</option>
  </select>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const paymentNS = createNamespacedHelpers("payment");

export default {
  name: "languageSwitch",
  methods: {
    ...paymentNS.mapActions(["setLanguage"]),
    setHtmlLang(lang) {
      document.getElementsByTagName("html")[0].setAttribute("lang", lang);
      var params = {
        language: lang,
      };
      this.setLanguage(params);
    },
  },
};
</script>
